
document.addEventListener('DOMContentLoaded' , () =>{
	// select 기본 place 색상값
	const $placeholder = $("select[placeholder]");
		if ($placeholder.length) {
		$placeholder.each(function() {
			const $this = $(this);

			// Initial
			$this.addClass("placeholder-shown");
			const placeholder = $this.attr("placeholder");
			$this.prepend(`<option value="" selected>${placeholder}</option>`);

			// Change
			$this.on("change", (event) => {
			const $this = $(event.currentTarget);
			if ($this.val()) {
				$this.removeClass("placeholder-shown").addClass("placeholder-hidden");
			} else {
				$this.addClass("placeholder-shown").removeClass("placeholder-hidden");
			}
			});
		});
	}

	//header
	if(document.querySelector('.header')){
		// const pcGnbBtn = document.querySelector('#pc-all-menu');
		// const mbGnb = document.querySelector('#mb-gnb-layer');
		const bodyOver = document.querySelector('body');

		const gnbBtnArray = document.querySelectorAll('.gnb-layer-btn');
		const gnbLayerArray = document.querySelectorAll('.gnb-layer');
		
		gnbBtnArray.forEach((btn) =>{
			btn.addEventListener('click' , (e)=>{
				let layerTit = btn.dataset.layer,
					btnClass = e.target.classList.contains('on');
					
				if(btnClass){
					bodyOver.classList.add('ovf2');
					document.querySelector(`.${layerTit}`).classList.add('off');
					e.target.classList.remove('on');
				}else{
					gnbLayerArray.forEach((el) =>{
						el.classList.add('off');
					})
					gnbBtnArray.forEach((el) =>{
						el.classList.remove('on');
					})
					bodyOver.classList.remove('ovf2');
					document.querySelector(`.${layerTit}`).classList.remove('off');
					e.target.classList.add('on'); 
				}
			})
		})

		//gnb
		if(document.querySelector('.mb-gnb-layer')){
			const listOpen = document.querySelectorAll('.mb-gnb-list__ul__li');

			listOpen.forEach((el,idx) =>{
				const btn = el.querySelector('.open-btn');

				btn.addEventListener('click' , ()=> {	
					btn.classList.toggle('on');
				})
			})
		}
	}

	// footer
	if(document.querySelector('.footer')){
		const topMove = document.querySelector('.footer-up');

		topMove.addEventListener('click' , ()=>{
			window.scrollTo({top : 0, behavior: "smooth"});
		})

		window.addEventListener('scroll' , ()=> {
			const headerH = document.querySelector('.header').clientHeight;

			if(scrollY <= headerH){
				topMove.classList.remove('on');
			} else{
				topMove.classList.add('on');
			}
		});
	}

	// lnb
	if(document.querySelector('.lnb-wrap')){
		if(window.innerWidth <= 768){
			const lnbWrap = document.querySelector('.lnb-wrap'),
				  tit = lnbWrap.querySelector('.btn-title'),
				  hiddenBox = lnbWrap.querySelector('.lnb-tit__list');
				// toggleBtn = document.querySelector('.js_toggle_btn');

			if(tit){
				tit.addEventListener('click' , ()=>{
					tit.classList.toggle('on');
					hiddenBox.classList.toggle('on');

					// if(toggleBtn.classList.contains('active')){
					// 	toggleBtn.classList.remove('active');
					// }
				})
			}
		}
	}

	// side menu
	if(document.querySelector('.side-menu')){
		if(window.innerWidth >= 768){
			const btnSideMenu = document.querySelectorAll(".js-btn-sideMenu");

			btnSideMenu.forEach((el) => {
				let btnSideMenuArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js-btn-sideMenu'));

				el.addEventListener('click' , function(e){
					if(el.classList.contains('active')){
						el.classList.remove('active');
					}else{
						btnSideMenuArray.forEach(function(el){
							el.classList.remove('active');
						});
						el.classList.add('active');
					}
				});
			});
		}
	}

	//datepicker
	if(document.querySelector('.datepicker')){
		$(".datepicker input").datepicker({
			dateFormat: 'yy-mm-dd',
			showOtherMonths: true,
			prevText: '이전 달',
			nextText: '다음 달',
			monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			dayNames: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
			showMonthAfterYear: true,
			yearSuffix: '',
			firstDay:1
		});
	}
	
	//file
	// if(document.querySelector('.file-plus')){
	// 	const fileList = document.querySelectorAll('.file-list');
	// 	let filePlus = document.querySelector('.file-plus');
	// 	let i = 0;

	// 	filePlus.addEventListener('click' , () => {
	// 		let fileArea = document.querySelector('.form__content--file'),
	// 			fileList = fileArea.querySelector('.file-list'),
	// 			fileClone = fileList.cloneNode(true);
				
	// 			fileArea.appendChild(fileClone);
	// 	})
			
	// 	fileList.forEach((el , idx) => {
	// 		let fileVal = el.querySelector('.upload-text'),
	// 			file = el.querySelector('.input-file');

	// 		file.addEventListener('change' , () => {
	// 			fileVal.value = file.value;
	// 		})
	// 	});
	// }
	
	//table scroll table box
    if(document.querySelector('.scroll-table-box')){
		const btnScrollTable = document.querySelectorAll('.js-btn-scroll-table');

		btnScrollTable.forEach((el) => {
			el.addEventListener('click' , () => {
				el.parentNode.classList.add('active');
			})
		});
	}

	// 비밀번호 보기
	const hiddenShow = document.querySelectorAll('.js_hiddenShow');

	class hiddenShowBox {
		constructor(target) {
			this.target = target;
			this.hiddenShowBtn = this.target.querySelector('.hidden-show__btn');
			this.hiddenShowIp = this.target.querySelector(".hidden-show__input");
		}

		hiddenShowFn() {
			const _this = this;
			
			this.hiddenShowBtn.addEventListener("click" , function(){
				if(_this.hiddenShowIp.type === 'password'){
					_this.hiddenShowIp.type = 'text';
					_this.hiddenShowBtn.classList.add('on');
				}else{
					_this.hiddenShowIp.type = 'password';
					_this.hiddenShowBtn.classList.remove('on');
				}
			})
		}
	}    
	hiddenShow.forEach(el => {        
		new hiddenShowBox(el).hiddenShowFn();
	});

	const fullImg = document.querySelectorAll('.js_fullImg');

	class fullImgBox {
		constructor(target) {
			this.target = target;
			this.fullImg = this.target.querySelector("img");
		}

		fullImgFn() {
			const _this = this;
			
			this.target.addEventListener("click" , function(){
				let imgSrc = _this.fullImg.src,
					viewImg = document.querySelector('#js-full-img-layer img');

				viewImg.src = imgSrc;
			})
		}
	}    
	fullImg.forEach(el => {        
		new fullImgBox(el).fullImgFn();
	});
});
